"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

!function (e, t) {
  for (var s in t) {
    e[s] = t[s];
  }
}(exports, function (e) {
  var t = {};function s(i) {
    if (t[i]) return t[i].exports;var n = t[i] = { i: i, l: !1, exports: {} };return e[i].call(n.exports, n, n.exports, s), n.l = !0, n.exports;
  }return s.m = e, s.c = t, s.d = function (e, t, i) {
    s.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: i });
  }, s.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
  }, s.t = function (e, t) {
    if (1 & t && (e = s(e)), 8 & t) return e;if (4 & t && "object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && e && e.__esModule) return e;var i = Object.create(null);if (s.r(i), Object.defineProperty(i, "default", { enumerable: !0, value: e }), 2 & t && "string" != typeof e) for (var n in e) {
      s.d(i, n, function (t) {
        return e[t];
      }.bind(null, n));
    }return i;
  }, s.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };return s.d(t, "a", t), t;
  }, s.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, s.p = "", s(s.s = 241);
}({ 0: function _(e, t) {
    e.exports = function () {
      function _class() {
        _classCallCheck(this, _class);
      }

      _createClass(_class, null, [{
        key: "triggerEvent",
        value: function triggerEvent(e, t) {
          var s = void 0;"function" == typeof Event ? s = new Event(t) : (s = document.createEvent("Event"), s.initEvent(t, !0, !0)), e.dispatchEvent(s);
        }
      }, {
        key: "getElementByAttribute",
        value: function getElementByAttribute(e, t) {
          return t ? document.querySelector("[" + e + "=\"" + t + "\"]") : document.querySelector("[" + e + "]");
        }
      }, {
        key: "getElementsByAttribute",
        value: function getElementsByAttribute(e, t) {
          return t ? document.querySelectorAll("[" + e + "=\"" + t + "\"]") : document.querySelectorAll("[" + e + "]");
        }
      }, {
        key: "getElementByAttributeWithinElement",
        value: function getElementByAttributeWithinElement(e, t, s) {
          return s ? e.querySelector("[" + t + "=\"" + s + "\"]") : e.querySelector("[" + t + "]");
        }
      }, {
        key: "isMouseOver",
        value: function isMouseOver(e) {
          return Array.prototype.slice.call(e.parentElement.querySelectorAll(":hover")).filter(function () {
            return e[0] == this;
          }).length > 0;
        }
      }, {
        key: "getElementsByAttributeWithinElement",
        value: function getElementsByAttributeWithinElement(e, t, s) {
          return s ? e.querySelectorAll("[" + t + "=\"" + s + "\"]") : e.querySelectorAll("[" + t + "]");
        }
      }, {
        key: "getElementByClassWithinElement",
        value: function getElementByClassWithinElement(e, t) {
          return e.querySelector("." + t);
        }
      }, {
        key: "maxWidthMobileViewports",
        value: function maxWidthMobileViewports() {
          return 940;
        }
      }, {
        key: "createEvent",
        value: function createEvent(e) {
          var t = void 0;return "function" == typeof Event ? t = new Event(e) : (t = document.createEvent("Event"), t.initEvent(e, !0, !0)), t;
        }
      }, {
        key: "isDesktop",
        value: function isDesktop() {
          return Math.max(document.documentElement.clientWidth, window.innerWidth || 0) > this.maxWidthMobileViewports();
        }
      }, {
        key: "isIE11",
        value: function isIE11() {
          return -1 !== navigator.userAgent.indexOf("MSIE") || navigator.appVersion.indexOf("Trident/") > -1;
        }
      }, {
        key: "getKeyCodeOnKeyDownEvent",
        value: function getKeyCodeOnKeyDownEvent(e) {
          var t = void 0;if (null != e) if (void 0 === e.code) switch (e.keyCode) {case 13:
              t = "Enter";break;case 38:
              t = "ArrowUp";break;case 40:
              t = "ArrowDown";break;case 8:
              t = "Backspace";break;case 9:
              t = "Tab";break;case 27:
              t = "Escape";break;case 33:
              t = "PageUp";break;case 34:
              t = "PageDown";break;case 32:
              t = "Space";break;default:
              t = void 0;} else t = e.code;return t;
        }
      }, {
        key: "getKeyboardFocusableElements",
        value: function getKeyboardFocusableElements(e) {
          return [].concat(_toConsumableArray(e.querySelectorAll('a[href], button, input, textarea, iframe, select, details,[tabindex]:not([tabindex="-1"])'))).filter(function (e) {
            return !function (e) {
              return "hidden" === window.getComputedStyle(e).visibility;
            }(e) && !e.hasAttribute("disabled") && !e.getAttribute("aria-hidden");
          });
        }
      }]);

      return _class;
    }();
  }, 2: function _(e, t, s) {
    "use strict";
    var i = s(0),
        n = s.n(i);t.a = function (e, t, s) {
      var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var r = n.a.getKeyboardFocusableElements(t),
          o = r[0],
          a = r[r.length - 1];if (s) {
        if (a.tagName && "IFRAME" === a.tagName) {
          var _e = document.createElement("div");_e.setAttribute("tabindex", "0"), a.parentNode.insertBefore(_e, a.nextSibling);
        }if (o.tagName && "IFRAME" === o.tagName) {
          var _e2 = document.createElement("div");_e2.setAttribute("tabindex", "0"), a.parentNode.insertBefore(_e2, a.nextSibling), o.parentNode.insertBefore(_e2, o);
        }i < 1 && (e.preventDefault(), setTimeout(function () {
          o.focus();
        }, 100)), e.shiftKey ? document.activeElement === o && (e.preventDefault(), a.focus()) : document.activeElement === a && (e.preventDefault(), o.focus());
      }
    };
  }, 241: function _(e, t, s) {
    e.exports = s(242);
  }, 242: function _(e, t, s) {
    "use strict";
    s.r(t), s.d(t, "Toast", function () {
      return o;
    });var i = s(0),
        n = s.n(i),
        r = s(2);
    var o = function () {
      function o(e) {
        _classCallCheck(this, o);

        this.element = e, this.id = this.element.getAttribute("data-rs-toast"), this.triggerElement = n.a.getElementByAttribute(this.attributes.show, this.id), this.closeElement = n.a.getElementByAttribute("data-rs-closable", "data-rs-toast-" + this.id), this.addEventHandlers(), this.closeTimeout, this.toastOpen, this.keystroke = 0;
      }

      _createClass(o, [{
        key: "addEventHandlers",
        value: function addEventHandlers() {
          var _this = this;

          this.triggerElement.addEventListener("click", function (e) {
            e.preventDefault(), _this.show(), _this.destroyCloseTimeout(), _this.createCloseTimeOut();
          }), this.closeElement.addEventListener("click", function () {
            _this.keystroke = 0;
          }), this.element.addEventListener("mouseenter", function () {
            _this.destroyCloseTimeout();
          }), this.element.addEventListener("mouseleave", function () {
            _this.closeTimeout = _this.createCloseTimeOut();
          }), document.addEventListener("keydown", function (e) {
            _this.handleButtonKeys(e);
          }), this.closeElement.addEventListener("click", function () {
            _this.keystroke = 0, _this.toastOpen = !1;
          });
        }
      }, {
        key: "show",
        value: function show() {
          this.toastOpen = !0, this.element.classList.remove(this.classes.closableClosed), this.element.classList.add(this.classes.show), this.element.classList.add(this.classes.toastActive);
        }
      }, {
        key: "hide",
        value: function hide() {
          this.toastOpen = !1, this.element.classList.remove(this.classes.show), this.element.classList.remove(this.classes.toastActive), this.element.classList.add(this.classes.closableClosed), this.keystroke = 0;
        }
      }, {
        key: "createCloseTimeOut",
        value: function createCloseTimeOut() {
          var _this2 = this;

          this.closeTimeout = setTimeout(function () {
            n.a.isMouseOver(_this2.element) || _this2.hide();
          }, 1e4);
        }
      }, {
        key: "handleButtonKeys",
        value: function handleButtonKeys(e) {
          if (null != e) switch (n.a.getKeyCodeOnKeyDownEvent(e)) {case "Tab":
              Object(r.a)(e, this.element, this.toastOpen, this.keystroke), this.toastOpen && this.keystroke++, this.toastOpen || (this.keystroke = 0);break;case "Escape":
              this.toastOpen && (this.hide(), this.triggerElement && this.triggerElement.focus()), this.toastOpen || (this.keystroke = 0);}
        }
      }, {
        key: "destroyCloseTimeout",
        value: function destroyCloseTimeout() {
          clearTimeout(this.closeTimeout);
        }
      }, {
        key: "attributes",
        get: function get() {
          return { show: "data-rs-toast-show" };
        }
      }, {
        key: "classes",
        get: function get() {
          return { image: "data-rs-toast-image", show: "show", closableClosed: "closable--closed", toastActive: "toast--active" };
        }
      }], [{
        key: "getSelector",
        value: function getSelector() {
          return "[data-rs-toast]";
        }
      }]);

      return o;
    }();
  } }));